import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "loan-document-workflows"
    }}>{`Loan Document Workflows`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Loan industries are often overwhelmed with tedious administrative tasks, leading to slower transaction times and ultimately unhappy borrowers. This is further complicated by stringent regulations, which can pose high risk with financial penalties despite the labor-intensive verification process. The most pressing pain points around managing loan origination documents include`}</p>
    <p>{`Adobe Acrobat Services allow companies to:`}</p>
    <ul>
      <li parentName="ul">{`Manually processing large volumes of documents in a variety of formats.`}</li>
      <li parentName="ul">{`Data entry errors and duplications of sensitive information in a high compliance environment`}</li>
      <li parentName="ul">{`Borrowers feeling rushed to review and sign the overwhelming stack of paperwork at closing, and frustrated at the lack of transparency of the entire process`}</li>
      <li parentName="ul">{`Borrower’s lack of understanding about the costs and risks from complex forms that are filled with legal and technical acronyms to fulfill federal, state and local government requirements`}</li>
    </ul>
    <p>{`Adobe Acrobat Services can help these organizations simplify the complex process by:`}</p>
    <ul>
      <li parentName="ul">{`Standardizing on a single digital workflow that lets users assemble, manipulate, collaborate on, fill in, and sign documents`}</li>
      <li parentName="ul">{`Making scanned PDFs searchable upon upload (OCR)`}</li>
      <li parentName="ul">{`Reducing manual data entry by automatically assembling data into documents from various sources of input`}</li>
      <li parentName="ul">{`Creating a seamless document viewing experience within the browser`}</li>
      <li parentName="ul">{`Adding additional security to the PDF`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A borrower applies for a loan. When they submit the loan application and supporting documents, the backend system converts uploaded documents to PDF format, compresses the files, and OCRs any scanned PDFs. Data is extracted from the uploaded documents and stored in a database. The borrower is then presented with a preview of the loan package as an embedded PDF and can add comments directly in case there are any questions to resolve with the loan officer. After application review and approval, the final loan documents are sent for signature using Adobe Acrobat Sign`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <p>{`In this solution, we will show how this process can be implemented within your organization to build a frictionless client service interface.`}</p>
    <ol>
      <li parentName="ol">{`Upon upload, the document(s) is passed to Create PDF, OCR, and Compress APIs to streamline and standardize PDFs coming into the service.`}</li>
      <li parentName="ol">{`PDF documents are sent to PDF Extract API to extract data, which can be stored in a database.`}</li>
      <li parentName="ol">{`Create a single loan package with Create PDF API.`}</li>
      <li parentName="ol">{`Render the application using the PDF Embed API in a secure portal so that borrowers can review and add questions / comments through annotation.`}</li>
      <li parentName="ol">{`Send final loan document for signatures with Adobe Acrobat Sign.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      